// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

.UserList_container__C4zL2 {
    height: 40rem;
}

.UserList_row__grAg8 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    box-shadow: none;
    background-color: #EDEDED;
    height: 4rem;
}

.UserList_subContainer__uH07O {
    display: flex;
    justify-content: left;
    align-items: center;
}

.UserList_brContainer__6FLs\\+ {
    margin-left: 8rem;
}

.UserList_image__e8ddv {
    margin: 0.4rem;
    height: 3rem;
    width: 3rem;
    border-radius: 5rem;
}

.UserList_textContainer__aUkUl {
    padding-left: 10;
    width: 15rem;
}

.UserList_text1__y0g7c {
    font-weight: 600;
    font-size: 18px;
}

.UserList_text2__8\\+42D {
    font-weight: 600;
    font-size: 14px;
}

.UserList_buttonContainer__5DoEI {
    padding: 10px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/User/UserList.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 29/3/2023\r\n */\r\n\r\n.container {\r\n    height: 40rem;\r\n}\r\n\r\n.row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 5px 0;\r\n    box-shadow: none;\r\n    background-color: #EDEDED;\r\n    height: 4rem;\r\n}\r\n\r\n.subContainer {\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n}\r\n\r\n.brContainer {\r\n    margin-left: 8rem;\r\n}\r\n\r\n.image {\r\n    margin: 0.4rem;\r\n    height: 3rem;\r\n    width: 3rem;\r\n    border-radius: 5rem;\r\n}\r\n\r\n.textContainer {\r\n    padding-left: 10;\r\n    width: 15rem;\r\n}\r\n\r\n.text1 {\r\n    font-weight: 600;\r\n    font-size: 18px;\r\n}\r\n\r\n.text2 {\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n}\r\n\r\n.buttonContainer {\r\n    padding: 10px 5px 0 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserList_container__C4zL2`,
	"row": `UserList_row__grAg8`,
	"subContainer": `UserList_subContainer__uH07O`,
	"brContainer": `UserList_brContainer__6FLs+`,
	"image": `UserList_image__e8ddv`,
	"textContainer": `UserList_textContainer__aUkUl`,
	"text1": `UserList_text1__y0g7c`,
	"text2": `UserList_text2__8+42D`,
	"buttonContainer": `UserList_buttonContainer__5DoEI`
};
export default ___CSS_LOADER_EXPORT___;
